module.exports = __webpack_public_path__ + "static/media/36.e9e07286.jpg";